export default () => ({
  trigger: {
    name: 'insurance_information.click_to_customer_service',
    params: {},
  },
  config: {
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
        content: 'customer_service',
      },
    },
    nonInt: true,
  },
});
